import { useParams } from "react-router";
import { MODELS, useMultiModel } from "../../../../../api";
import { ShellContent } from "../../../../shell/Shell.jsx";
import { Spinner } from "../../../../../design-system/utils/Spinner/Spinner.jsx";
import tokens from "../../../../../design-system/tokens.js";
import { useSparkContext } from "../../../context/SparkContext.jsx";
import { FullShowroomEntryWithData } from "./FullShowroomEntryWithData.jsx";

const FullShowroomEntry = () => {
  const { smallTeamId } = useParams();
  const { workshop, spark, settings } = useSparkContext();
  const [me, showroomData, teamMembers] = useMultiModel([
    MODELS.ME,
    MODELS.SMALL_TEAM_SHOWROOM_ENTRY(smallTeamId, true),
    MODELS.SMALL_TEAM_MEMBERS(smallTeamId),
  ]);

  const [unseenComments] = useMultiModel([
    showroomData.entry?.id
      ? MODELS.COMMENTS_UNSEEN({
          workshopId: workshop.id,
          showroomEntryId: showroomData.entry.id,
        })
      : null,
  ]);

  // unseenComments is only fetched once the entry id is known; while that
  // dependent fetch hasn't resolved (or there is no entry), show the spinner.
  if (unseenComments === undefined) return <Spinner />;

  return (
    <ShellContent bg={tokens.color.full.gray800}>
      <FullShowroomEntryWithData
        entry={showroomData.entry}
        comments={showroomData.comments}
        myReaction={showroomData.myReaction}
        myCommentReactions={showroomData.myCommentReactions}
        teamMembers={teamMembers}
        me={me}
        myRoles={workshop.roles}
        commentsEnabled={settings.commentsEnabled}
        backPath="../showroom"
        unseenComments={unseenComments}
        sparkId={spark.id}
        workshopId={workshop.id}
      />
    </ShellContent>
  );
};

export default FullShowroomEntry;
